<template>
  <a-layout-content>
    <h2>JOYland 赛事管理</h2>
    <a-row>
      <a-col :xs="24" :sm="12">
        <a-card title="创建新赛事">
          <a-input placeholder="赛事名" v-model="contest_name" />
          <a-textarea placeholder="海报地址" autosize v-model="contest_img" />
          <a-button type="primary" size="large" @click="contest_create()">创建赛事</a-button>
        </a-card>
      </a-col>
      <a-col :xs="24" :sm="12">
        <a-card title="批量注册并加入比赛" v-if="!this.show_all">
          <a-textarea
            placeholder="输入用户qq（以换行符间隔）"
            :auto-size="{ minRows: 2, maxRows: 10 }"
            v-model="register_user"
          />
          <a-button @click="register_all(user)">注册</a-button>
        </a-card>
        <a-card title="批量用户信息" v-else>
          <a-list bordered :dataSource="user_list">
            <a-list-item slot="renderItem" slot-scope="item">
              <div>{{item.uname}}  {{item.name}}  {{item.pass}}  {{item.bot_send}}</div>
              </a-list-item>
            <div slot="header">用户名  用户  密码  bot发送详情</div>
          </a-list>
        </a-card>
      </a-col>
      <p></p>
      <a-col :xs="24" :sm="12">
        <a-card title="为用户报名">
          <a-collapse :bordered="false">
            <a-collapse-panel key="1" header="点击展开">
              <a-list bordered :dataSource="list">
                  <a-list-item slot="renderItem" slot-scope="item">
                    <a slot="actions" @click="join_contest(item.uid)">为他报名</a>
                    <div>{{item.uid}}-{{item.name}}</div>
                    </a-list-item>
                  <div slot="header">当前赛事：{{system.name}}</div>
                </a-list>
            </a-collapse-panel>
          </a-collapse>
        </a-card>
      </a-col>
      <a-col :xs="24" :sm="12">
        <a-card title="注册用户并加入比赛">
          <a-form :form="registerform" class="register-form" @submit="registerSubmit">
            <a-form-item>
                <a-input
                  v-decorator="['uname',{ rules: [{ required: true,message: '请输入账号（qq）' }] }]"
                  placeholder="账号"
                >
                  <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)" />
                </a-input>
              </a-form-item>
            <a-form-item>
              <a-button type="primary" html-type="submit" class="login-form-button">注册</a-button>
            </a-form-item>
          </a-form>
        </a-card>
      </a-col>
    </a-row>
  </a-layout-content>
</template>
<script>
export default {
  data () {
    return {
      user: [],
      system: [],
      list: [],
      show_all: false,
      user_list: [],
      register_user: '',
      contest_name: '',
      contest_img: ''
    }
  },
  beforeCreate () {
    this.registerform = this.$form.createForm(this)
  },
  mounted () {
    this.$http
      .get('https://auction-api.joyland.top/user')
      .then(res => {
        if (!res.data || res.data.code === 401) {
          this.$message.info('请检查登录状态')
          this.$router.push('/login')
        } else {
          if (res.data.is_admin) {
            this.user = res.data
          } else {
            this.$message.info('请检查权限')
            this.$router.push('/dashboard')
          }
        }
      })
    this.$http.get('https://auction-api.joyland.top/getallu').then(res => {
      this.list = res.data
    })
    this.$http.get('https://auction-api.joyland.top/system').then(res => {
      this.system = res.data
    })
  },
  methods: {
    push (name) {
      this.$router.push('/' + name)
    },
    registerSubmit (e) {
      e.preventDefault()
      this.registerform.validateFields((err, values) => {
        if (!err) {
          const data = {
            uname: values.uname,
            main_type: values.main_type,
            second_type: values.second_type,
            name: values.name,
            password: this.$crypto.Encrypt(values.password)
          }
          this.$http
            .post('https://auction-api.joyland.top/register', data)
            .then(response => {
              if (response.data.code === 200) {
                this.$message.info('注册成功')
              }
            })
        }
      })
    },
    contest_create () {
      const data = {
        name: this.contest_name,
        img: this.contest_img
      }
      this.$http
        .post('https://auction-api.joyland.top/contest_create', data)
        .then(response => {
          if (response.data.code === 200) {
            this.$message.info('创建成功')
          }
        })
    },
    join_contest (uid) {
      this.$http.get('https://auction-api.joyland.top/contest_join?uid=' + uid + '&cid=' + this.system.id).then(res => {
        if (res.data.code === 200) {
          this.$message.info('注册成功')
        }
      })
    },
    register_all () {
      const data = {
        user: this.register_user
      }
      this.$http
        .post('https://auction-api.joyland.top/register_all', data)
        .then(response => {
          if (response.data.code === 200) {
            this.user_list = response.data.result
            this.show_all = true
            this.$message.info('创建成功')
          }
        })
    }
  }
}
</script>
